export default __webpack_public_path__ + "4832e5c1ed621e1cacecac6695755a8d.svg";